<template>
    <div class="form-builder-step">
        <div class="form-builder-fields">
            <template v-for="(field,index) in description.fields">
                <Field v-if="getTokenForField(field.token)"  :key="index" :ref="field.token" :description="field" :token="getTokenForField(field.token)" v-model="configuration[field.token]"></Field>
                <p class="form-message" v-if="!field.token && field.message === true" v-html="fieldLabelWithReplacment(field)">

                </p>
                <component v-if="!field.token && !field.message && field.component" :is="getComponentName(field)" v-bind="getComponentProps(field)" v-model="configuration[field.key]"></component>
            </template>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import _find from 'lodash/find'

    import Field from './Field'

    import Conflicts from '@c/plugins/formbuilder/elements/Conflicts'
    import GroupItemSelector from '@c/plugins/formbuilder/elements/GroupItemSelector'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Field,
            Conflicts,
            GroupItemSelector
        },
        computed: {

        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            getTokenForField(token){
                return _find(this.tokens, item => {
                    return item.key == token
                })
            },

            getComponentName(field){
                if(typeof field.component === 'object'){
                    return field.component.name
                }
                return field.component
            },

            getComponentProps(field){
                if(typeof field.component === 'object'){
                    return field.component.props
                }
                return null
            },

            validateStep(){
                let validations = [],
                    thereAreErrors = false

                console.log(Object.keys(this.$refs))



                Object.keys(this.$refs).forEach(item => {
                    let field = this.$refs[item][0]
                    validations.push(field.validateField(this.configuration[item]))
                })

                validations.forEach((item,index) => {
                    console.log(item)
                    if(item && item.success === false){
                        thereAreErrors = true
                    }
                })

                return !thereAreErrors

            },

            fieldLabelWithReplacment(field){
                return field.label
            }


        },
        mounted: function () {

        },
        name: '',
        props: {
            stepIndex:{
                type: Number,
                required: true
            },
            description: {
                type: Object,
                required: true
            },
            tokens: {
                type: Array,
                required: true
            },
            configuration: {
                type: Object,
                default(){
                    return {}
                }
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .form-builder-step{
        width: 100%;
        height: 100%;

        .form-builder-fields{
            max-width: 600px;
            margin: auto;

            .form-message{
                a{
                    color: $main-color;
                    font-weight: $bold;

                    &:hover{
                        color: $secondary-color;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/Step.vue